import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {FieldGroup} from '../../interfaces/FieldGroup';
import {FieldGroupsResponse} from '../../interfaces/FieldGroupsResponse';
import {environment} from '../../../../../environments/environment';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {Field} from '../../interfaces/Field';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {ErrorService} from '../../../utilities/services/error/error.service';

@Injectable()
export class FieldGroupService {
  private headers = new Headers({'Content-Type': 'application/json'});
  private fieldGroupsUrl = 'fieldgroup';

  constructor(private http: AuthHttp, public errorDialogService: ErrorService) {
  }

  public getFieldGroups(limit: number = 10, page = 1, type?: number): Promise<FieldGroupsResponse> {
    const params = <any>{
      limit: limit,
      page: page
    };
    if (type)
      params.type = type;
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}`;
    return this.http
      .get(url, {params: params})
      .toPromise()
      .then(response => response.json() as FieldGroupsResponse)
      .catch(this.handleError);
  }

  public getAllFieldGroups(type?: number): Promise<FieldGroupsResponse> {
    return this.getFieldGroups(99999, 1, type);
  }

  public getFieldGroup(id): Promise<FieldGroup> {
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}/${id}`;
    return this.http
      .get(url)
      .toPromise()
      .then(response => response.json() as FieldGroup)
      .catch(this.handleError);
  }

  public create(newItem: FieldGroup) {
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}`;
    return this.http
      .post(url, JSON.stringify(newItem), {headers: this.headers})
      .map(response => response.json() as FieldGroup)
      .toPromise()
      .catch(error => this.handleError(error));
  }

  public update(id: number, data): Promise<FieldGroup> {
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}/${id}`;
    return this.http
      .put(url, data)
      .toPromise()
      .then(response => response.json() as FieldGroup)
      .catch(error => this.handleError(error));
  }

  public delete(id: number): Promise<void> {
    const url = `${environment.baseUrl}${this.fieldGroupsUrl}/${id}`;
    return this.http
      .delete(url, {headers: this.headers})
      .toPromise()
      .then(() => null)
      .catch(this.handleError);
  }

  private handleError(error: Response) {
    console.log('handleError', error);
    this.errorDialogService.openDialog(error);
    return Promise.reject(error);
  }

  public archivedFields(id: number, limit: number = 10, page = 1, name: string = ''): Promise<Pagination<Field>> {
    return this.http
      .get(`${environment.baseUrl}${this.fieldGroupsUrl}/${id}/archivefield?limit=${limit}&page=${page}&name=${name}`)
      .map((res) => res.json()).toPromise();
  }

  public getFields() {
      const url = `${environment.baseUrl}fields`;
      return this.http
          .get(url)
          .toPromise()
          .then(response => response.json() as Field[])
          .catch(this.handleError);
  }


    public getServicesWithFields() {
        const url = `${environment.baseUrl}${this.fieldGroupsUrl}/services`;
        return this.http
            .get(url, {})
            .toPromise()
            .then(response => response.json() as FieldGroup[])
            .catch(this.handleError);
    }



  public restore(id: number) {
    return this.http.put(`${environment.baseUrl}${this.fieldGroupsUrl}/${id}/archivefield/${id}`, '').toPromise();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/services/field-group/field-group.service.ts